import React from "react";
import { API_ENDPOINTS } from "@/src/config/api.js";

const Question = () => {
  let [responseData, setResponseData] = React.useState("");
  const fetchData = React.useCallback(() => {
    fetch(API_ENDPOINTS.question.latest)
      .then(response => response.json())
      .then((response) => {
        setResponseData(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  React.useEffect(() => {
    fetchData();
  }, []);
  // return <div>{responseData && responseData.quote && `${responseData.tracks[0].title}`}</div>;
  // const quote = (responseData && responseData.quote) || {};
  if (responseData) {
    const question = responseData;
    return (<div className="bg-neutral-900 rounded-lg p-4">
      <h2 className="font-bold text-lg mb-2">QUESTION OF THE DAY</h2>
      <p className="text-lg text-gray-300 mb-4"><a href="/question">{question.question}</a></p>
      <p className="text-sm text-gray-300">Vote or add your own answer to this and many other brilliant questions  &raquo;</p>
    </div>)

  } else {
    return <div>Loading...</div>;
  }
};

export default Question;
